import styled from 'styled-components';
import media from 'styled-media-query';

import { pxToRem } from '../../../functions';

export const Container = styled.section`
  height: 100%;
  overflow: hidden;

  h1 {
    font-size: 1.5rem;
    font-family: 'SFProText-Bold', sans-serif;
  }

  table {
    position: relative;

    width: 100%;
    height: auto;
    border-collapse: collapse;

    margin: 1.5rem 0;

    ::after {
      position: absolute;
      bottom: -12px;

      content: '';
      width: 100%;
      height: 1px;

      background: #ccc;
    }

    :last-child::after {
      background: transparent;
    }

    :first-child {
      margin: 0.5rem 0;
    }

    tr {
      padding: 0 ${pxToRem(8)};

      display: grid;
      grid-template-columns: 0.6fr 2fr;

      :nth-child(odd) {
        background-color: rgba(40, 49, 49, 0.06);
      }

      :nth-child(even) {
        background-color: rgba(40, 49, 49, 0.1);
      }

      :hover {
        background-color: rgba(40, 49, 49, 0.15);
      }
    }

    h2 {
      margin-top: 1rem;

      font-size: 24px;
      font-family: 'SFProText-Regular', sans-serif;
    }

    td,
    th {
      padding: 8px 0;

      text-align: left;
    }
  }

  .table-info {
    height: 100%;

    padding-bottom: ${pxToRem(28)};

    ${media.lessThan('1024px')`
      padding-bottom: ${pxToRem(38)};
    `}
  }
`;
